
export const SvgIcons = [
  'email', 'password', 'logs', 'settings', 'back-arrow', 'next-page', 'next-page-arrow', 'attachment', 'phone', 'form',
  'next-page-arrow-curve', 'excel', 'pdf', 'ms-word', 'columns', 'page-break', 'add', 'edit', 'view', 'send',
  'person', 'logout', 'close', 'menu', 'option', 'search', 'copy', 'empty', 'document', 'download', 'order',
  'commitment', 'policy', 'government', 'work', 'notification', 'parliament', 'menu-white', 'training', 'password-reset'
];
